import React from "react"

const SVG = ({
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 100 90'
}) => (
  <svg
    width={width}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      d='M66,40 L66,48 L74,53 L74,35 L66,40 Z M33,54 L33,35 C33,32 36,32 36,32 L60,32 C60,32 63,32 63,34.9698227 C63,34.9698226 63,53.9780197 63,53.9780199 C63,57 60,57 60,57 L36,57 C36,57 33,57 33,54 Z'
    />
  </svg>
)

export default SVG